import { useUserLogout, useUser } from '@auth-v2';
import { useAtomValue } from 'jotai';
import startCase from 'lodash/startCase';
import { useLocation, useNavigate } from 'react-router';

import { useTranslate } from '@i18n';
import { isActiveCurrentUserAtom, activityIdAtom, studentIdAtom, activityAtom } from '@store';
import {
    ListIcon,
    GearIcon,
    GoalIcon,
    Menu,
    MenuItem,
    SignOutIcon,
    typography,
    StudentIcon,
    Text,
    Above,
    Only,
    UserIcon,
    colors,
} from '@ui';

import { LINKS, ROUTES } from '../../utils/routes';

import * as css from './Navigation.css';

export const MenuLabel = () => {
    const t = useTranslate();
    const { data: user } = useUser();
    return (
        <Text variant="h3">
            <Only bp="xs" spans={2}>
                <UserIcon color={colors.blue[500]} weight="fill" />
            </Only>
            <Above bp="md">
                {user?.user_metadata?.['name'] ? startCase(user?.user_metadata?.['name']) : t('menu.actions')}
            </Above>
        </Text>
    );
};

export const NavigationMenu = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const t = useTranslate();
    const isActivities = location.pathname === '/activities';

    const isActiveCurrentUser = useAtomValue(isActiveCurrentUserAtom);

    const activityId = useAtomValue(activityIdAtom);
    const activity = useAtomValue(activityAtom);
    const logout = useUserLogout(ROUTES.LOGIN);

    const studentId = useAtomValue(studentIdAtom);

    return (
        <Menu label="Actions" align="left" buttonSize={24} menuType="main" className={css.menu}>
            <MenuItem onClick={() => navigate(LINKS.getUserSettings())} style={{ justifyContent: 'flex-start' }}>
                <GearIcon size={18} />
                <span
                    className={typography({
                        variant: 'p',
                    })}
                >
                    {t('menu.user_settings')}
                </span>
            </MenuItem>
            {!isActiveCurrentUser && !isActivities && (
                <MenuItem onClick={() => navigate(LINKS.getStudentSettings())} style={{ justifyContent: 'flex-start' }}>
                    <StudentIcon size={18} />
                    <span
                        className={typography({
                            variant: 'p',
                        })}
                    >
                        {t('menu.student_settings')}
                    </span>
                </MenuItem>
            )}

            {!isActivities && (
                <MenuItem
                    onClick={() => navigate(LINKS.getActivities(studentId))}
                    style={{ justifyContent: 'flex-start' }}
                >
                    <ListIcon size={18} />
                    <span
                        className={typography({
                            variant: 'p',
                        })}
                    >
                        {t('menu.activities')}
                    </span>
                </MenuItem>
            )}
            {activity?.layoutId && (
                <MenuItem
                    onClick={() => navigate(LINKS.getGoalReport(activity.layoutId!))}
                    style={{ justifyContent: 'flex-start' }}
                >
                    <GoalIcon size={18} color="currentColor" />
                    <span
                        className={typography({
                            variant: 'p',
                        })}
                    >
                        {t('menu.goal_report')}
                    </span>
                </MenuItem>
            )}
            {activityId >= 0 && (
                <MenuItem onClick={() => navigate(LINKS.getReport())} style={{ justifyContent: 'flex-start' }}>
                    <GoalIcon size={18} color="currentColor" />
                    <span
                        className={typography({
                            variant: 'p',
                        })}
                    >
                        {t('menu.activity_report')}
                    </span>
                </MenuItem>
            )}
            <MenuItem onClick={() => logout.mutate()} style={{ justifyContent: 'flex-start' }}>
                <SignOutIcon size={18} />
                <span
                    className={typography({
                        variant: 'p',
                    })}
                >
                    {t('menu.logout')}
                </span>
            </MenuItem>
        </Menu>
    );
};
